module.exports = __webpack_public_path__ + "img/desktop_careers_top_img.e939d014.jpg";